export enum WhatsappMessageType {
  text = "text",
  image = "image",
  video = "video",
  sticker = "sticker",
  audio = "audio",
  document = "document",
}
